import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from "react-icons/md";
import { BsBank } from "react-icons/bs";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { FaRegBuilding } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import {Layout, CustomerProfile, CustomerConfig} from '../../../../components';
import {handleApi,inputDate,getChangedFields} from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditCustomer = () => {
  const location = useLocation();
  const initialCustomer = location.state?.initialCustomer;
  
  // FIX: Initialize react-hook-form directly with defaultValues from initialCustomer.
  // This removes the need for a separate 'customer' state variable that was causing conflicts.
  const { reset, control, register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: initialCustomer
  });
  
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [displayImg, setDisplayImg] = useState(''); 
  const [imgType, setImgType] = useState('');
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);

  //fetch categories and uoms when the component mounts
    useEffect(() => {
        fetchCountries();
        fetchRegions();
        fetchCities(); 
    }, []);
    
    
    // Reset the form when `customer` state changes (initial or after submit)
    useEffect(() => {reset(initialCustomer); }, [initialCustomer, reset]);
    
    const fetchCountries = async () => {
        const apiEndpoint = 'countries';
        const apiMethod = 'GET';
        const parameters = {};
        setIsLoading(true);
        const params = {};
        try {
          const response = await handleApi(apiEndpoint, params, userData, apiMethod, parameters);
          if (response.error) {
            console.error('Error fetching customer categories', response.errorMessage);
            return; // Exit function to avoid further processing
          }
          const { status, statusText } = response;
          if (status === 200) {
            const fetchedCountries = response.data; // fetched categories
            //format Customer categories  for select options
            const transformedCountries = fetchedCountries.map(country => ({
              value: country.id,
              label: country.name
            }));
            // Now update the state with the transformed data
            setCountries(transformedCountries);
          } else {
            console.error(`Error ${status}: ${statusText}`); // Handle non-200 responses
          }
        } catch (error) {
          console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
        } finally {setIsLoading(false);}
      };
    
      
      const fetchRegions = async (selectedCountryId) => {
        const apiEndpoint = 'regions';
        const apiMethod = 'GET';
        const parameters = {country_id:selectedCountryId};
        setIsLoading(true);
        const data = {};
        try {
          const response = await handleApi(apiEndpoint, data, userData, apiMethod, parameters);
          if (response.error) {
            console.error('Error fetching Regions ', response.errorMessage);
            return; // Exit function to avoid further processing
          }
          const { status, statusText } = response;
          if (status === 200) {
            const fetchedRegions = response.data; // fetched categories
            //format uoms  for select options
            const transformedRegions = fetchedRegions.map(region => ({
              value: region.id,
              label: region.name
            }));
            setRegions(transformedRegions);  // Now update the state with the transformed data
          } else {console.error(`Error ${status}: ${statusText}`);   }// Handle non-200 responses
        
        } catch (error) {console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
        } finally {setIsLoading(false);}
      };
    
      const fetchCities = async (selectedCountryId) => {
        const apiEndpoint = 'districts';
        const apiMethod = 'GET';
        const parameters = {country_id:selectedCountryId};
        setIsLoading(true);
        const data = {};
        try {
          const response = await handleApi(apiEndpoint, data, userData, apiMethod, parameters);
     
          if (response.error) {
            console.error('Error fetching Regions ', response.errorMessage);
            return; // Exit function to avoid further processing
          }
          const { status, statusText } = response;
    
          if (status === 200) {
            const fetchedCities= response.data; // fetched categories
            //format uoms  for select options
            const transformedCities = fetchedCities.map(city => ({
              value: city.id,
              label: city.name
            }));
            setCities(transformedCities); // Now update the state with the transformed data
          } else {console.error(`Error ${status}: ${statusText}`);  }// Handle non-200 responses
         
        } catch (error) {console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
        } finally {setIsLoading(false);}
      };
      
      
    
  
  const handleCancel = () => {
    // FIX: reset form  to initial values
    reset(initialCustomer);
    
  };

  const navigate = useNavigate(); 

  const handleClosePage = () => {
   navigate(-1);
  };


  const handleChange = (event) => {
    const { name, value } = event.target;
  };
  
  const handleCustomerProfileFormSubmit = async (dataFromForm) => {
    try {
    //   console.log('Form data received from react-hook-form (safe stringify):', JSON.stringify(dataFromForm, null, 2));
    } catch (e) {
      console.error("Failed to stringify `dataFromForm`. Circular reference found:", dataFromForm);
      toast.error("Form data is corrupted. Check the console for details.");
      setIsLoading(false);
      return;
    }
    const payload=getChangedFields(initialCustomer,dataFromForm)
    // const payload = {    // Create payload 
    //     id: dataFromForm.id,
    //     first_name: dataFromForm.first_name,
    //     last_name: dataFromForm.last_name,
    //     salutation: dataFromForm.salutation,
    //     gender:dataFromForm.gender,
    //     job_title: dataFromForm.job_title,
    //     email: dataFromForm.email,
    //     phone_number: dataFromForm.phone_number,
    //     category_id: dataFromForm.category_id,
    //     hire_date: inputDate(dataFromForm.hire_date),
    //     date_of_birth: inputDate(dataFromForm.date_of_birth),
    //   };
      
    console.log('payload sir ',payload)
      
    try {
      console.log('Final payload to send to API (safe stringify):', JSON.stringify(payload, null, 2));
    } catch (e) {
      console.error("Final payload has a circular reference. Inspect the object below.", payload);
      toast.error("The final payload is corrupted. Check the console for details.");
      setIsLoading(false);
      return;
    }

    const apiMethod = payload.id ? 'PUT' : 'POST';
    const parameters = { ...(payload.id && { id: payload.id }) };
    setIsLoading(true);
    try {
      const response = await handleApi('customers', payload, userData, apiMethod, parameters);
      if (response.status === 200 || response.status === 201) {
        toast.success('Customer profile saved successfully!');
        // FIX: The component will now display the updated data without a full reset.
        // The parent state no longer needs to be explicitly updated here.
      } else {
        toast.error(`Error saving customer: ${response.statusText || 'An unknown error occurred'}`);
      }
    } catch (error) {
      toast.error('Error saving customer: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 512 512" fill="${currentColor}"><path d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M256,79.5c37.5,0,67.9,30.4,67.9,67.9S293.5,215.4,256,215.4S188.1,185,188.1,147.4S218.5,79.5,256,79.5z M256,441.6c-70.5,0-134.4-29.3-177.3-76.3c-0.3-0.3-0.5-0.6-0.8-1c-0-0-0-0-0-0.1C72,322,112.5,274.6,161.4,274.6h189.1c48.9,0,89.4,47.4,83.6,90.5c-0,0-0,0-0.1,0.1c-0.3,0.3-0.5,0.7-0.8,1C390.4,412.3,326.5,441.6,256,441.6z" /></svg>`;
  const base64Svg = btoa(unescape(encodeURIComponent(svgString)));
  const defaultPhotoUrl = `data:image/svg+xml;base64,${base64Svg}`;

  const photoUrl = isImageLoading ? null : (displayImg && imgType ? `data:${imgType};base64,${displayImg}` : defaultPhotoUrl);
  return (
    <Layout>
      <div className="m-1 sm:m-2">
        <div className="relative flex justify-between items-center">
          <h1 className="text-center font-bold flex-grow">EDIT CUSTOMER</h1>
          <button
            onClick={handleClosePage}
            className="p-1 rounded-lg text-red-400 bg-white hover:bg-gray-50 hover:text-gray-600"
          >
            <MdOutlineCancel color={currentColor} size={30} />
          </button>
        </div>
        
        <ToastContainer position="top-center" autoClose={2000} />

        {isLoading ? (
          <div className="flex items-center flex-col py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="loading" />
            <p className="mt-2 text-white">Loading. Please wait...</p>
          </div>
        ) : (
          <div className="bg-white p-2 sm:p-4 my-4 my-auto mx-auto max-w-[80%] rounded-xl shadow-2xl">
            <div className="mx-auto border-b border-gray-400 bg-gray-500 transition-all duration-200 cursor-pointer rounded-xl shadow-2xl p-8">
              <CustomerProfile
                  fields={CustomerConfig}
                  control={control}
                  register={register}
                  photo={photoUrl}
                  onChange={handleChange}
                  countries={countries}
                  regions={regions}
                  cities={cities}

                  onSubmit={handleSubmit(handleCustomerProfileFormSubmit)}
                  customerData={initialCustomer} // FIX: Pass initialCustomer here instead of a mutable state variable.
                  onCancel={handleCancel}
                  errors={errors}
                  reset={reset}
                  isLoading={isLoading}
                />
              </div>
            
          </div>
        )}
      </div>
    </Layout>
  );
};
export default EditCustomer;
